import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

declare var jQuery: any;
declare var solid: any;

@Injectable()
export class SolidUserConfigurationService {

    constructor(private _http: HttpClient) {
        
    }

    initialize(): void {
        this._http.get('/SolidUserConfiguration/GetAll')
            .subscribe(result => {
                jQuery.extend(true, solid, JSON.parse(JSON.stringify(result)));
            });
    }

}